import { EditOutlined, EyeOutlined } from '@ant-design/icons';
import { faTags } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BoostInput } from '@affiliates/types/globalTypes';
import { Button } from '@frontend/shadcn/components/ui/button';
// import { Select, SelectContent, SelectItem, SelectTrigger } from '@frontend/shadcn/components/ui/select';
import { EllipsisIcon } from '@revfluence/fresh-icons/solid/esm';

import * as React from 'react';

interface BoostTagProps {
  onEdit?: (e?: React.MouseEvent) => void;
  onMore?: (e?: React.MouseEvent) => void;
  onPreview?: (e?: React.MouseEvent) => void;
  boost: BoostInput
}

export function BoostTag({ boost, onEdit, onMore, onPreview }: BoostTagProps) {
  return (
    <div className="flex items-center w-full min-h-[48px] bg-white rounded-xl shadow border px-6 py-2 justify-between">
      <div className="flex items-center gap-2">
        <div className="flex items-center bg-blue-2 rounded-full h-6 w-6 justify-center ">
          <FontAwesomeIcon
            icon={faTags}
            className="h-3 w-3 text-blue-4"
          />
        </div>
        <div className="font-medium text-base truncate flex-1 min-w-0">{boost.label}</div>
      </div>
      <div className="flex items-center gap-1 ml-4">
        <Button
          variant="outline"
          size="smallIcon"
          type="button"
          onClick={onPreview}
          className="p-2 cursor-pointer transition-all duration-300 ease-in-out hover:bg-grey-1 hover:border-grey-5 hover:text-grey-5 border-0"
          aria-label="Preview boost"
        >
          <EyeOutlined />
        </Button>

        <Button
          variant="outline"
          size="smallIcon"
          type="button"
          onClick={onEdit}
          className="p-2 cursor-pointer transition-all duration-300 ease-in-out hover:bg-grey-1 hover:border-grey-5 hover:text-grey-5 border-0"
          aria-label="Edit boost"
        >
          <EditOutlined />
        </Button>
        <button
          className="hover:bg-gray-100 rounded p-1"
          aria-label="More"
          onClick={onMore}
          type="button"
        >
          <EllipsisIcon className="w-3 h-3 text-grey-6" />

        </button>
        {/* <Select>
          <SelectTrigger
            className="p-2 cursor-pointer transition-all duration-300 ease-in-out hover:bg-grey-1 hover:border-grey-5 hover:text-grey-5 border-0"
            showIcon={false}
            onClick={onMore}
          >
            <EllipsisIcon className="w-3 h-3 text-grey-6" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="delete" className="text-red-5">
              Delete
            </SelectItem>
          </SelectContent>
        </Select> */}
      </div>
    </div>
  );
}

export default BoostTag;
